// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   TableContainer,
//   Pagination,
//   Stack,
//   Paper,
//   Checkbox,
//   Tooltip,
//   Button,
//   TextField,
//   Chip,
// } from "@mui/material";
// import {
//   MenuItem,
// } from "@mui/material";
// import API from "../../utils/Axios.utils";
// import { Radio } from "@mui/material";


// const AssignSupplier = ({
//   jobIds,
//   onSuccess,
//   setAlert,
//   setAlertType,
//   setAlertContent
// }) => {
// //   const [supplierId, setSupplierId] = useState("");
// //   const [suppliers, setSuppliers] = useState([]);

// const [selectedSupplier, setSelectedSupplier] = useState(null);
// const [loading, setLoading] = useState(false);
// const [suppliers, setSuppliers] = useState([]);



//   const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
//   const config = { headers: { Authorization: `Bearer ${token}` } };

// //   useEffect(() => {
// //     API.get("/api/supplier/all", config)
// //       .then(res => setSuppliers(res.data.data))
// //       .catch(() => {});
// //   }, []);

// useEffect(() => {
//   const fetchSuppliers = async () => {
//     setLoading(true);
//     try {
//       const res = await API.get(
//         `/api/users/assign_supplier_list?jobIds=${jobIds.join(",")}`,
//         config
//       );
//       setSuppliers(res?.data?.result || []);
//     } catch (err) {
//       setAlertContent("Failed to load suppliers");
//       setAlertType("error");
//       setAlert(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (jobIds?.length) fetchSuppliers();
// }, [jobIds]);


// const handleAssign = async () => {
//   if (!selectedSupplier) {
//     setAlertContent("Please select a supplier");
//     setAlertType("error");
//     setAlert(true);
//     return;
//   }

//   try {
//     setLoading(true);
//     const res = await API.post(
//       "/api/users/supplier/sendmail-multi",
//       {
//         jobIds,
//         supplierId: selectedSupplier,
//       },
//       config
//     );

//     setAlertContent(res?.data?.message);
//     setAlertType("success");
//     setAlert(true);
//     onSuccess();
//   } catch (err) {
//     setAlertContent(err?.response?.data?.message);
//     setAlertType("error");
//     setAlert(true);
//   } finally {
//     setLoading(false);
//   }
// };


//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//        <TableContainer component={Paper}>
//   <Table size="small">
//     <TableHead>
//       <TableRow>
//         <TableCell />
//         <TableCell>Supplier Name</TableCell>
//         <TableCell>Organisation</TableCell>
//         <TableCell>Core Skills</TableCell>
//         <TableCell>Preferred</TableCell>
//       </TableRow>
//     </TableHead>

//     <TableBody>
//       {suppliers.map((sup) => (
//         <TableRow key={sup.supplier_id}>
//           <TableCell>
//             <Radio
//               checked={selectedSupplier === sup.supplier_id}
//               onChange={() => setSelectedSupplier(sup.supplier_id)}
//             />
//           </TableCell>

//           <TableCell>{sup.name}</TableCell>
//           <TableCell>{sup.org_name}</TableCell>
//           <TableCell>
//             {(sup.jobCoreSkill || [])
//               .slice(0, 3)
//               .map((s) => s.name)
//               .join(", ")}
//           </TableCell>
//           <TableCell>
//             {sup.preffered_supplier === "Y" ? "Yes" : "No"}
//           </TableCell>
//         </TableRow>
//       ))}
//     </TableBody>
//   </Table>
// </TableContainer>

//       </Grid>

//       <Grid item xs={12} textAlign="center">
//        <Button
//   variant="contained"
//   disabled={!selectedSupplier || loading}
//   onClick={handleAssign}
//   style={{ background: "#2777AA" }}
// >
//   Send Mail ({jobIds.length} Jobs)
// </Button>

//       </Grid>
//     </Grid>
//   );
// };

// export default AssignSupplier;

import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Radio,
  Chip,
  Stack
} from "@mui/material";
import API from "../../utils/Axios.utils";
import useAuth from "../../hooks/useAuth";

const AssignSupplier = ({
  jobIds,
  onSuccess,
  setAlert,
  setAlertType,
  setAlertContent
}) => {
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [loading, setLoading] = useState(false);

  const { token } = useAuth();
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  };

  // 🔹 STEP 1: Load suppliers
  useEffect(() => {
    if (!jobIds || jobIds.length === 0) return;

    API.post(
      "/api/job/assign-supplier-list",
      { jobIds },
      config
    )
      .then(res => {
        setSuppliers(res?.data?.data || []);
      })
      .catch(() => {
        setSuppliers([]);
      });
  }, [jobIds]);

  // 🔹 STEP 2: Submit
  const handleSubmit = async () => {
    if (!selectedSupplier) {
      setAlertContent("Please select a supplier");
      setAlertType("error");
      setAlert(true);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        supplierId: selectedSupplier,
        jobIds: jobIds
      };

      const res = await API.post(
        "/api/job/assign-supplier",
        payload,
        config
      );

      // Report what actually happened, naming the supplier, instead of a generic "completed"
      const stats = res?.data?.stats || {};
      const supplierData = suppliers.find((s) => s.supplier_id === selectedSupplier);
      const supplierLabel = supplierData
        ? `${supplierData.name}${supplierData.org_name ? ` (${supplierData.org_name})` : ""}`
        : "the supplier";
      const jobsLabel = (n) => `${n} job${n === 1 ? "" : "s"}`;
      const sent = stats.success || 0;

      const extras = [];
      if (stats.skipped) extras.push(`${jobsLabel(stats.skipped)} already sent`);
      if (stats.invalidStatus) extras.push(`${jobsLabel(stats.invalidStatus)} not in an assignable status`);
      if (stats.errors) extras.push(`${stats.errors} failed`);

      if (sent > 0) {
        setAlertContent(
          `${jobsLabel(sent)} sent to ${supplierLabel}.${extras.length ? ` ${extras.join(", ")}.` : ""}`
        );
        setAlertType(extras.length ? "warning" : "success");
      } else {
        setAlertContent(
          `No jobs sent to ${supplierLabel}${extras.length ? `: ${extras.join(", ")}` : ""}.`
        );
        setAlertType(stats.errors ? "error" : "warning");
      }
      setAlert(true);
      setLoading(false);

      onSuccess();
    } catch (error) {
      setLoading(false);
      setAlertContent(error?.response?.data?.message || "Something went wrong");
      setAlertType("error");
      setAlert(true);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Supplier Name</TableCell>
                <TableCell>Organisation</TableCell>
                <TableCell>Core Skills</TableCell>
                <TableCell>Preferred</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {suppliers.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No suppliers found
                  </TableCell>
                </TableRow>
              ) : (
                suppliers.map((sup) => (
                  <TableRow key={sup.supplier_id}>
                    <TableCell>
                      <Radio
                        checked={selectedSupplier === sup.supplier_id}
                        onChange={() => setSelectedSupplier(sup.supplier_id)}
                        disabled={sup.isAllAssigned}
                      />
                    </TableCell>
                    <TableCell>
                      {sup.name}
                      {sup.isAllAssigned ? (
                        <Chip label="Already Sent" size="small" color="error" variant="outlined" sx={{ ml: 1, height: '20px', fontSize: '10px', verticalAlign: 'middle' }} />
                      ) : sup.assignedJobIds && sup.assignedJobIds.length > 0 && (
                        <Chip label={`${sup.assignedJobIds.length}/${jobIds.length} Already Sent`} size="small" color="warning" variant="outlined" sx={{ ml: 1, height: '20px', fontSize: '10px', verticalAlign: 'middle' }} />
                      )}
                    </TableCell>
                    <TableCell>{sup.org_name}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ maxWidth: '200px' }}>
                        {sup.jobCoreSkill && sup.jobCoreSkill.slice(0, 3).map((skill) => (
                          <Chip
                            key={skill.id}
                            label={skill.name}
                            size="small"
                            sx={{
                              fontSize: '0.75rem',
                              height: '24px'
                            }}
                          />
                        ))}
                        {sup.jobCoreSkill && sup.jobCoreSkill.length > 3 && (
                          <Chip
                            label={`+${sup.jobCoreSkill.length - 3}`}
                            size="small"
                            color="default"
                            sx={{
                              fontSize: '0.75rem',
                              height: '24px'
                            }}
                          />
                        )}
                      </Stack>
                    </TableCell>
                    <TableCell>
                      {sup.preffered_supplier === "Y" ? "Yes" : "No"}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          disabled={!selectedSupplier || loading}
          onClick={handleSubmit}
          style={{ background: "#2777AA" }}
        >
          {(() => {
            const supplierData = suppliers.find(s => s.supplier_id === selectedSupplier);
            const alreadySent = supplierData ? supplierData.assignedJobIds.length : 0;
            const activeCount = jobIds.length - alreadySent;
            return `Send Mail for ${activeCount} New Job${activeCount === 1 ? "" : "s"}${alreadySent ? ` (${alreadySent} already sent)` : ""}`;
          })()}
        </Button>
      </Grid>
    </Grid>
  );
};

export default AssignSupplier;

